//  filepath: src/components/dashboard/CustomTooltip.jsx
import { fmtUSDMaybe, fmtIntMaybe } from "../../utils/number";

export default function CustomTooltip({ active, payload, label, mode }) {
  if (!active || !payload || !payload.length) return null;

  const now = new Date();
  const currYear = now.getUTCFullYear();
  const currMonth = now.getUTCMonth(); // 0-indexed
  const dayNumber = Number(label);

  const d = new Date(Date.UTC(currYear, currMonth, dayNumber));

  const fmtUTCDate = (opts) =>
    d.toLocaleDateString("en-US", { ...opts, timeZone: "UTC" });

  const point = Object.fromEntries(payload.map((p) => [p.dataKey, p.value]));
  const isPending = point.currPending != null;

  const fmtCurr = mode === "Revenue" ? fmtUSDMaybe : fmtIntMaybe;
  const fmtPrev = mode === "Revenue" ? fmtUSDMaybe : fmtIntMaybe;

  // Pending label (e.g. "October Revenue Pending")
  const pendingLabel =
    mode === "Revenue"
      ? `${fmtUTCDate({ month: "long" })} Revenue Pending`
      : `${fmtUTCDate({ month: "long" })} Reservations Pending`;

  // 🧠 Previous month label (e.g. September 2025)
  const prevMonthDate = new Date(Date.UTC(currYear, currMonth - 1, 1));
  const prevMonthLabel = prevMonthDate.toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });

  return (
    <div className="rounded-xl border bg-white shadow-xl p-3 min-w-[240px]">
      {/* 📅 Top: Full Date */}
      <div className="font-semibold text-gray-900 mb-2">
        {fmtUTCDate({
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })}
      </div>

      {/* 🔵 Current Month Row */}
      {isPending ? (
        <div className="flex items-center justify-between py-1">
          <div className="flex items-center gap-2">
            <span className="h-2.5 w-2.5 rounded-full border border-blue-500" />
            <span className="text-indigo-600 font-semibold">
              {pendingLabel}
            </span>
          </div>
          <div className="font-semibold text-gray-500">—</div>
        </div>
      ) : (
        <div className="flex items-center justify-between py-1">
          <div className="flex items-center gap-2">
            <span className="h-2.5 w-2.5 rounded-full bg-blue-500" />
            <span className="text-gray-600">
              {fmtUTCDate({ month: "long", year: "numeric" })}
            </span>
          </div>
          <div className="font-semibold text-gray-900">
            {fmtCurr(point.curr)}
          </div>
        </div>
      )}

      {/* Divider */}
      <div className="my-2 h-px bg-gray-100" />

      {/* ⚪ Previous Month Row */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span
            className="h-2.5 w-2.5 rounded-full"
            style={{ background: "#94a3b8" }}
          />
          <span className="text-gray-600">{prevMonthLabel}</span>
        </div>
        <div className="font-medium text-gray-700">{fmtPrev(point.prev)}</div>
      </div>
    </div>
  );
}
